// src/api/mockData.js
// Dataset in memoria per la modalità demo (nessuna persistenza, si azzera al reload).

export const mockEsperienze = [
  {
    esperienza_id: 'exp-001',
    consulente_id: 'res-4471',
    risorsa_nome: 'Marco Bellini',
    denominazione_progetto: 'Piattaforma AI Governance',
    cliente_finale: 'Gruppo Hera',
    stato: 'E1',
    ruolo: 'AI Governance Specialist',
    settore_l1: 'Energy & Utilities',
    dominio_l1: 'AI Strategy',
    data_inizio: '2025-11-01',
    data_fine_prevista: '2026-11-01',
    capacita_percentuale: 80,
    scheda_id: 'sch-001',
    tecnologie: ['Python', 'LangChain', 'Azure OpenAI'],
    main_contractor: 'ISA Digital Consulting',
    contesto_contrattuale: 'Contratto quadro pluriennale',
    note: 'Coinvolgimento anche su workshop interni di change management.',
    referente_commerciale: 'Elena Sartori',
    preavvisi_reminder: ['1 mese', '2 settimane'],
  },
  {
    esperienza_id: 'exp-002',
    consulente_id: 'res-2298',
    risorsa_nome: 'Giulia Ferraro',
    denominazione_progetto: 'Interoperabilità dati sanitari',
    cliente_finale: 'Commissione Europea — DG SANTE',
    stato: 'E1',
    ruolo: 'Data Governance Advisor',
    settore_l1: 'Public Sector',
    dominio_l1: 'Data Governance',
    data_inizio: '2026-02-15',
    data_fine_prevista: '2026-12-15',
    capacita_percentuale: 60,
    scheda_id: 'sch-002',
    tecnologie: ['FHIR', 'HL7'],
    main_contractor: '',
    contesto_contrattuale: 'Appalto UE',
    note: '',
    referente_commerciale: 'Paolo Greco',
    preavvisi_reminder: ['2 mesi', '1 mese', '1 settimana'],
  },
  {
    esperienza_id: 'exp-003',
    consulente_id: 'res-3150',
    risorsa_nome: 'Luca Moretti',
    denominazione_progetto: 'Assessment sicurezza infrastrutture',
    cliente_finale: 'AGEA',
    stato: 'E2',
    ruolo: 'Cybersecurity Consultant',
    settore_l1: 'Public Sector',
    dominio_l1: 'Cybersecurity',
    data_inizio: '2025-03-01',
    data_fine_prevista: '2025-12-01',
    data_fine_effettiva: '2025-11-20',
    feedback_cliente: 'Ottima capacità di analisi, remediation plan apprezzato dal team IT del cliente.',
    capacita_percentuale: 100,
    scheda_id: 'sch-003',
    tecnologie: ['Nessus', 'ISO 27001'],
    main_contractor: '',
    contesto_contrattuale: '',
    note: '',
    referente_commerciale: 'Elena Sartori',
    preavvisi_reminder: ['1 settimana', '3 giorni'],
  },
];

export const mockSchede = {
  'sch-001': {
    scheda_id: 'sch-001',
    titolo: 'Piattaforma AI Governance — Gruppo Hera',
    risorsa_nome: 'Marco Bellini',
    referente_hr: 'Sara Conti',
    sommario:
      'Definizione del framework di AI Governance per i casi d\'uso prioritari del gruppo, con toolset di AI Readiness e policy conformi all\'AI Act.',
    utilizzabile: true,
    marcatura_autore: 'Elena Sartori',
    marcatura_nota: 'Referenza forte per proposte settore energy.',
    version: 3,
    ultima_compilazione: '2026-08-20',
    compilazioni: [
      {
        tipo: 'SA-2b',
        data: '2026-08-20',
        risposte: {
          'Attività svolte e deliverable prodotti nel periodo':
            'Definizione del framework di governance AI, workshop con i process owner, prima versione del catalogo casi d\'uso prioritari.',
          'Strumenti e tecnologie utilizzati concretamente nel lavoro operativo': 'Python, LangChain, Azure OpenAI, Confluence.',
          'Apprendimenti maturati nel periodo':
            'Importanza di coinvolgere Legal fin dalle prime fasi per l\'allineamento all\'AI Act.',
        },
      },
      {
        tipo: 'SA-2b',
        data: '2026-05-10',
        risposte: {
          'Attività svolte e deliverable prodotti nel periodo':
            'Avvio del progetto, raccolta requisiti con gli stakeholder di gruppo, prima bozza di policy.',
        },
      },
    ],
  },
  'sch-002': {
    scheda_id: 'sch-002',
    titolo: 'Interoperabilità dati sanitari — DG SANTE',
    risorsa_nome: 'Giulia Ferraro',
    referente_hr: 'Marco Villa',
    sommario:
      'Supporto alla definizione degli standard di interoperabilità per lo scambio di dati sanitari tra stati membri.',
    utilizzabile: false,
    marcatura_autore: null,
    marcatura_nota: null,
    version: 1,
    ultima_compilazione: '2026-06-02',
    compilazioni: [
      {
        tipo: 'SA-2b',
        data: '2026-06-02',
        risposte: {
          'Attività svolte e deliverable prodotti nel periodo':
            'Analisi comparativa degli standard FHIR/HL7 adottati dagli stati membri, prima bozza di raccomandazione tecnica.',
        },
      },
    ],
  },
  'sch-003': {
    scheda_id: 'sch-003',
    titolo: 'Assessment sicurezza infrastrutture — AGEA',
    risorsa_nome: 'Luca Moretti',
    referente_hr: 'Sara Conti',
    sommario: 'Valutazione della postura di sicurezza e piano di remediation su infrastrutture critiche.',
    utilizzabile: true,
    marcatura_autore: 'Paolo Greco',
    marcatura_nota: 'Caso di successo per proposte Public Sector.',
    version: 2,
    ultima_compilazione: '2025-11-20',
    compilazioni: [
      {
        tipo: 'SA-4',
        data: '2025-11-20',
        risposte: {
          'Contributo più significativo apportato nell\'ingaggio':
            'Identificazione di 12 vulnerabilità critiche e definizione del piano di remediation prioritizzato.',
          'Elementi che si affronterebbero diversamente':
            'Coinvolgere prima il team infrastrutturale per accelerare la raccolta evidenze.',
          'Competenze acquisite o consolidate nel corso dell\'esperienza': 'Hardening di infrastrutture legacy in ambito PA.',
          'Elementi da mettere in evidenza raccontando l\'esperienza a un potenziale cliente (facoltativa)':
            'Riduzione dell\'80% delle vulnerabilità critiche in 6 mesi.',
        },
      },
      {
        tipo: 'SA-2b',
        data: '2025-08-14',
        risposte: {
          'Attività svolte e deliverable prodotti nel periodo': 'Vulnerability assessment su 40 sistemi, report intermedio.',
        },
      },
    ],
  },
};

export const mockSearchIndex = [
  { scheda_id: 'sch-001', titolo: 'Piattaforma AI Governance — Gruppo Hera', risorsa_nome: 'Marco Bellini', estratto: 'AI Governance, AI Act, toolset di readiness' },
  { scheda_id: 'sch-002', titolo: 'Interoperabilità dati sanitari — DG SANTE', risorsa_nome: 'Giulia Ferraro', estratto: 'Data governance, standard di interoperabilità sanitaria' },
  { scheda_id: 'sch-003', titolo: 'Assessment sicurezza infrastrutture — AGEA', risorsa_nome: 'Luca Moretti', estratto: 'Cybersecurity, remediation, infrastrutture critiche' },
];

// GET /kl/template — struttura indicativa, non verificata contro il backend reale (gate G03)
export const mockTemplate = {
  sezioni: [
    { nome: 'Intestazione', campi: ['Risorsa', 'Cliente finale', 'Ruolo', 'Periodo'] },
    { nome: 'Sommario', campi: ['Sintesi generata automaticamente dalle compilazioni SA-2b/SA-4'] },
    { nome: 'Attività e risultati', campi: ['Deliverable prodotti', 'Tecnologie utilizzate', 'Valore per il cliente'] },
    { nome: 'Chiusura (se disponibile)', campi: ['Contributo principale', 'Competenze acquisite', 'Elementi per referenza commerciale'] },
  ],
};
